import React from 'react'
import "./Footer-style.css"

export default function Footer() {
  return (
    <>
    <section id="footer">

      <div className="footer-heading"><h3>Please Support and Share Protonity To Your Friends So They Can also Learn something New.</h3></div>
      <div id="footer-contents">

        <div className="content">
          <div className="main-content">
            <h3>Way to Connect With Us</h3>
            <ul>
              <li><a href="/">Google Mail</a></li>
              <li><a href="/">Whatsapp</a></li>
              <li><a href="/">Twitter</a></li>
              <li><a href="https://www.instagram.com/nitinrathodofficial/" rel="noreferrer" target={'_blank'}>Instagram</a></li>
              <li><a href="/">Facebook</a></li>
              <li><a href="/">Mobile Number</a></li> 
              <li><a href="/">Snapchat</a></li>
            </ul>
          </div>
        </div>

        <div className="content">
          <div className="main-content">
            <h3>About Our Teammates</h3>
            <ul>
              <li><a href="https://www.instagram.com/vaishnavi_jadhav_007/" rel="noreferrer" target={'_blank'}>Vaishnavi Jadhav</a></li>
              <li><a href="https://www.instagram.com/p/CZWpVWjvLlSywYmHCdjiYJp2W6T-4rmFxnrSkM0/" rel="noreferrer" target={'_blank'}>Neha Kadam</a></li>
              <li><a href="https://www.instagram.com/sandesh_jadhav___/" rel="noreferrer" target={'_blank'}>Sandesh Jadhav</a></li>
              <li><a href="https://www.instagram.com/itsayantamboli/" rel="noreferrer" target={'_blank'}>Ayan Shaikh</a></li>
              <li><a href="https://www.instagram.com/akshay_849/" rel="noreferrer" target={'_blank'}>Akshay Salve</a></li>
              <li><a href="https://www.instagram.com/sandip_ade_sankalp/" rel="noreferrer" target={'_blank'}>Sandip Adhe</a></li> 
              <li><a href="https://www.instagram.com/_sachin_is_here__/" rel="noreferrer" target={'_blank'}>Sachin Ghule</a></li>
              <li><a href="https://www.instagram.com/pawarspeaks._/" rel="noreferrer" target={'_blank'}>Ankit Pawar</a></li>  
            </ul>
          </div>
        </div>

        <div className="content">
          <div className="main-content">
            <h3>Our Expertise</h3>
            <ul>
              <li><a href="/">HTML 5</a></li>
              <li><a href="/">CSS 3</a></li>
              <li><a href="/">C ++</a></li>
              <li><a href="/">Python</a></li>
              <li><a href="/">Java</a></li>
              <li><a href="/">JavaScript</a></li>
              <li><a href="/">MongoDB</a></li>
              <li><a href="/">ExpressJs</a></li>
              <li><a href="/">NodeJs</a></li>
              <li><a href="/">ReactJS</a></li> 
            </ul>
          </div>
        </div>

      </div>
      <div className="copyright"><p> &#169; All Right Reserve For Protonity 2022 by <a href="https://www.instagram.com/nitinrathodofficial/" rel="noreferrer" target={'_blank'}>Nitin Ram Rathod</a></p></div>
    </section>
    
    
    </>
  )
}
